module.exports = __webpack_public_path__ + "static/img/dpBd.c1b84db.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/zhongBrand/dpBd.png
// module id = ldlq
// module chunks = 0